<template>
  <div class="page_error">
    <div>
      <v-icon class="error_icon">hourglass_empty</v-icon>
    </div>
    <div class="error_text">
      <h1>408</h1>
      <h3>Tempo esgotado</h3>
      <p>O tempo de processamento do seu pedido expirou.</p>
    </div>
  </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>
